<template>
  <div class="body">
    <div class="title">
      发布帖子
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"  class="dsadf">
            <span class="dsadf">首页</span>
            </el-breadcrumb-item>
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item  :to="{ path: '/tieziguanli' }" >
            <span class="dsadf">帖子管理</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item  class="dsadf">发布帖子</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-card>
      <el-form ref="form" :model="form" label-width="80px"  :rules="resetFormRules"   :label-position="labelPosition">
        <el-form-item label="用户名" label-width="10%">
         {{fabubankuai}}
        </el-form-item>
        <el-form-item label="发布者ID" label-width="10%">
          <el-input v-model="form.name"  style="width: 294px" placeholder="请输入发布者ID"></el-input>
        </el-form-item>
        <el-form-item label="发布标题" label-width="10%">
          <el-input v-model="form.name"  style="width: 294px" placeholder="请输入发布标题"></el-input>
        </el-form-item>
        <el-form-item label="图片" label-width="10%">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="物品描述" label-width="10%">
          <el-input v-model="form.name"  style="width: 550px" placeholder="请输入物品描述"  type="textarea"  :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="物品状态" label-width="10%">
          <el-select  placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出售价格" label-width="10%">
          <el-input v-model="form.name"  style="width: 294px" placeholder="请输入出售价格"></el-input> 元
        </el-form-item>
        <el-form-item label="联系电话" label-width="10%">
          <el-input v-model="form.name"  style="width: 294px" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="发布状态" label-width="10%">
          <el-radio-group v-model="form.radio">
            <el-radio :label="3">上架</el-radio>
            <el-radio :label="6">下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-button type="primary">提交</el-button>
    </el-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'index',
  computed: {
    ...mapState(['fabubankuai'])
  },
  data () {
    return {
      labelPosition: 'left',
      form: {
        radio: 3
      },
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }]
    }
  },
  methods: {
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    }
  }
}
</script>

<style lang="less" scoped>
.body {
  display: flex;
  flex-direction: column;

.title {
  opacity: 1;
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Heavy;
  font-weight: 800;
  text-align: left;
  color: #2e2e2e;
  letter-spacing: 0px;
  margin-bottom: 35px;
  display: flex;
  flex-direction: row;
  align-items: center;

.fansk {
  margin-top: 30px;
  margin-left: 32px;
}

.dsadf {
  color: #3D9AFF;
}

}
}
</style>
